<app-breadcrumb [title]="'Profile'" [breadcrumb]="'Profile'"></app-breadcrumb>
<!-- personal deatail section start -->
<section class="section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-3">
                <div class="account-sidebar" (click)="ToggleDashboard()">
                    <a hre="javascript:void(0)" class="popup-btn">
                        Minha Conta
                    </a>
                </div>
                <div class="dashboard-left" [class.open]="openDashboard">
                    <div class="collection-mobile-back" (click)="ToggleDashboard()">
                        <span class="filter-back">
                            <i class="fa fa-angle-left" aria-hidden="true"></i> back
                        </span>
                    </div>
                    <div class="block-content">
                        <ul>
                            <li class="active"><a href="javascript:void(0)">Dados da Conta</a></li>
                            <!-- <li><a href="javascript:void(0)">Address Book</a></li>
                            <li><a href="javascript:void(0)">My Orders</a></li>
                            <li><a href="javascript:void(0)">My Wishlist</a></li>
                            <li><a href="javascript:void(0)">Newsletter</a></li>
                            <li><a href="javascript:void(0)">My Account</a></li> -->
                            <li><a (click)="openModal(editTrocaSenhaModal)">Alterar Senha</a></li>
                            <li class="last"><a (click)="logoutS()">Log Out</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-9">
                <div class="dashboard-right">
                    <div class="dashboard">
                        <div class="page-title">
                            <h2>Dados da Conta</h2>
                        </div>
                        <div class="welcome-msg">
                            <p>Olá, {{usuarioCompleto?.nome}} !</p>
                            <p>Este é seu painel de checagem de seus dados cadastrados em nosso sistema.</p>
                        </div>
                        <div class="box-account box-info">
                            <div class="box-head">
                                <h2>Informações da Conta</h2>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="box">
                                        <div class="box-title">
                                            <h3>Contato</h3>
                                            <!-- <a href="javascript:void(0)">Edit</a> -->
                                        </div>
                                        <div class="box-content">
                                            <h6>{{usuarioCompleto?.cliente?.email}}</h6>
                                            <h6>{{usuarioCompleto?.cliente?.telefone | mask: '(00) 0000-0000'}}</h6>
                                            <h6>{{usuarioCompleto?.ramal | mask: '(00) 00000-0000'}}</h6>
                                            <h6>{{usuarioCompleto?.login}}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="box">
                                        <div class="box-title">
                                            <h3>Unidade</h3>
                                            <!-- <a href="javascript:void(0)">Edit</a> -->
                                        </div>
                                        <div class="box-content">
                                            <h6>Unidade: {{usuarioCompleto?.cliente?.unidade?.nome}}</h6>
                                            <h6>Responsável: {{usuarioCompleto?.cliente?.unidade?.nomeResponsavel}}</h6>
                                            <h6>Email: {{usuarioCompleto?.cliente?.unidade?.email}}</h6>
                                            <h6>Telefone: {{usuarioCompleto?.cliente?.unidade?.telefone | mask: '(00) 0000-0000'}}</h6>
                                            <h6>Telefone Plantão: {{usuarioCompleto?.cliente?.unidade?.telefonePlantao | mask: '(00) 0000-0000'}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div class="box">
                                    <div class="box-title">
                                        <h3>Endereço</h3>
                                        <!-- <a href="javascript:void(0)">Manage Addresses</a> -->
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h6>{{usuarioCompleto?.cliente?.endereco}}</h6>
                                            <h6>Cidade: {{usuarioCompleto?.cliente?.cidade?.nome}} - {{usuarioCompleto?.cliente?.cidade?.estado?.sigla}} </h6>
                                        </div>
                                        <div class="col-sm-6">
                                            <h6>Bairro: {{usuarioCompleto?.cliente?.bairro}} - CEP: {{usuarioCompleto?.cliente?.cep}}</h6>
                                            <h6>País: {{usuarioCompleto?.cliente?.cidade?.estado?.pais?.nome}}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #editTrocaSenhaModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="editSenhaLabel">Trocar Senha</h5>
        <button type="button" class="btn-close" (click)="closeBtnClick()" aria-label="Close">
        </button>
    </div>

    <div class="modal-body">
        <form [formGroup]="editTrocaSenha">
            <div class="mb-3 row">
                <label for="novaS" class="col-sm-4 col-form-label">Nova Senha</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" formControlName="novaS" id="novaS">
                </div>
            </div>

            <div class="mb-3 row">
                <label for="senhaA" class="col-sm-4 col-form-label">Senha Antiga</label>
                <div class="col-sm-8">
                    <input type="text" class="form-control" formControlName="senhaA" id="senhaA">
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">Fechar</button>
                <button type="submit" class="btn btn-info"(click)="abrirConfirmacao(confirmacaoModal, 'trocar senha', 0)">Salvar</button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #confirmacaoModal let-modal>
    <div class="modal-body">
        <form (ngSubmit)="confirmacao()">
            <div class="mb-3 row">
                Você deseja {{acao}}?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="fechar()">Fechar</button>
                <button type="submit" class="btn btn-info">Ok</button>
            </div>
        </form>
    </div>
</ng-template>
<!-- Section ends -->